import { Middleware } from '@reduxjs/toolkit';
import { RootState } from 'app/root-reducer';

export const organizationContextSwitcherMiddleware: Middleware<{}, RootState> =
  (store) => (next) => (action) => {
    const result = next(action);
    if (action.type === 'jobSeekerOnBehalfOfOrganizationAdmin/setOnBehalfOfOrganizationAdmin') {
      const state = store.getState();
      if (state.jobSeekerOnBehalfOfOrganizationAdmin.onBehalfOfOrganizationAdmin) {
        store.dispatch({ type: 'jobSeekerOnBehalfOfOrganization/clearOnBehalfOfOrganization' });
      }
    }
    return result;
  };
